import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/be/components/Pages/Custom/Universal/Book.tsx");
